import { call, put, takeEvery } from "redux-saga/effects";
import { bienLaiThuApi } from "../../../api/bien-lai/bienLaiThuApi";
import { IBienLaiSelectBySinhVienRequest } from "../../../model/request/bien-lai/IBienLaiSelectBySinhVienRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eBienLaiViewActionTypeIds,
  IBienLaiViewActionTypes,
} from "./../../action-types/bien-lai/IBienLaiViewActionTypes";

export function* bienLaiViewSaga(): any {
  yield takeEvery(eBienLaiViewActionTypeIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IBienLaiViewActionTypes): any {
  const request = action.payload as IBienLaiSelectBySinhVienRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.SelectBySinhVien, request);
  if (res.is_success) {
    yield put(
      rootActions.bienLai.bienLaiView.LOAD_SUCCESS({
        request,
        data: res.data,
      })
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiView.LOAD_ERRR({
        request,
        data: res.data,
      })
    );
  }
}
